import CASL from '@/utils/constants/casl'

export default {
  path: 'payment-package-electric',
  children: [
    {
      path: '',
      name: 'payment-package-electric.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PAKET_PEMBAYARAN_PLN
      },
      component: () => import('./list/PaymentPackageElectricListPage.vue')
    },
    {
      path: 'add',
      name: 'payment-package-electric.add',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PAKET_PEMBAYARAN_PLN
      },
      component: () => import('./form/PaymentPackageElectricFormPage.vue')
    },
    {
      path: ':uid',
      name: 'payment-package-electric.edit',
      meta: {
        action: 'read', // TODO: Should be 'update'?
        subject: CASL.ACCESS.PAKET_PEMBAYARAN_PLN
      },
      component: () => import('./form/PaymentPackageElectricFormPage.vue')
    }
  ]
}
